<template>
  <div>
    <div class="header">
      <div class="main clearfix">
        <div class="logo">
          <h1>2020年全国硕士研究生招生考试
            <div class="sys-name">
              <div class="sys-name-content">网上报名平台</div>
            </div>
          </h1>
        </div>
        <div class="user">
          <a class="home mark" href="/">
            <i class="ivu-icon ivu-icon-ios-home f-22"></i>&nbsp;首页
          </a>
          <a class="user-name" title="13611070198">用户</a>
          <a class="exit" >退出</a>
        </div>
      </div>
    </div>

    <div class="main-wrapper" id="app">
      <h2 class="yzwb-header">报名须知</h2>
      <div class="yzwb-box">
        <p class="ch-paragraph14 text-indent0">1、网上报名时间：2019年10月10日至10月31日，预报名（报名数据有效）：2019年9月24日至9月27日，每天9:00～22:00，应届毕业生除了可在预报名阶段报名外，也可在正式报名阶段报名。
        <p class="ch-paragraph14 text-indent0">2、现场确认时间：由各省级招办自行确定公布，请关注各省网报公告，考生报考信息以现场确认报考点数据为准。</p>
        <p class="ch-paragraph14 text-indent0">3、下载准考证时间：2019年12月14日～2019年12月24日（24小时开放），考生可用学信网的用户名和密码登录研招网，进入网上报名栏目下载。</p>
        <p class="ch-paragraph14 text-indent0">4、开始报名前，请考生仔细阅读 <a href="http://yz.chsi.com.cn/help/" target="_blank" class="c-default">常见问题</a> 以及 <a href="http://yz.chsi.com.cn/sswbgg/" target="_blank" class="c-default">各单位网报公告</a>，提前准备好 <a href="https://yz.chsi.com.cn/kyzx/other/201809/20180905/1718876721.html" target="_blank" class="c-default">需要填写的信息</a> 。报名过程中，<span class="c-warning">请考生仔细阅读网报页面提示文字，并认真填写选择</span>，避免造成无效报名。</p>
        <p class="ch-paragraph14 text-indent0">5、网上报名期间，考生可自行填报、修改或重新填报报名信息，但一位考生只能保留一条有效报名信息。如需重新填报报名信息（新增报名），须取消已有的报名，已取消的报名信息不可用于现场确认。报名过程中如需修改信息，建议退出网上报名系统，重新登录修改。现场确认前，考生可查看及下载网上报名信息。推免生需在 <a href="http://yz.chsi.com.cn/tm/" target="_blank" class="c-default">推免服务系统</a> 报名。</p>
        <p class="ch-paragraph14 text-indent0">6、生成报名号后本次报名才为成功（如果选择的报考点采取网上交费，交费成功后才算报名成功），报名号是现场确认的重要凭证，<span class="c-warning">请考生务必牢记</span>。</p>
        <p class="ch-paragraph14 text-indent0">7、考生可登录 <a href="http://my.chsi.com.cn/" target="_blank" class="c-default">学信档案</a> 验证本人学籍或学历，学信档案注册与否并不影响网报过程。</p>
        <p class="ch-paragraph14 text-indent0">8、请考生牢记学信网的用户名和密码（为避免个人信息泄露，请设置复杂密码并定期修改），后期下载准考证、参加调剂仍然需要使用。</p>
        <p class="ch-paragraph14 text-indent0">9、一位考生只能保留一条有效报名信息。</p>
      </div>
      <div class="t-center margin-bottom-30">
        <router-link to="/wangshangdiaocha" style="color: white"><el-button type="primary">确定</el-button></router-link>
      </div>
    </div>
    <div class="footer c-tip">
      <div class="main clearfix">

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'baomingxuzhi'
}
</script>

<style scoped>
  @import "../../../static/wb-pc.css";
  a{ text-decoration:none}
</style>



// WEBPACK FOOTER //
// src/components/baomingxuzhi/baomingxuzhi.vue